import { Footer } from '../components/Footer.js';
import { Nav } from '../components/Nav.js';

const PLANS = [
  {
    id: 'tablette',
    name: 'Tablette seule',
    price: '249',
    monthly: null as string | null,
    tag: "L'essentiel, sans engagement.",
    features: [
      'Tablette Cadran prête à brancher',
      'App famille (iOS / Android)',
      'Agenda, messages, photos',
      'Alertes médicaments & RDV',
      'Mises à jour incluses',
    ],
    featured: false,
    cta: 'Commander',
  },
  {
    id: 'famille',
    name: 'Famille',
    price: '249',
    monthly: '10',
    tag: 'Le plus populaire pour rester proche.',
    features: [
      'Tout de « Tablette seule »',
      'Support prioritaire',
      'Sauvegardes chiffrées cloud',
      'Mises à jour automatiques OTA',
      'Accès multi-proches illimité',
    ],
    featured: true,
    badge: 'Le plus populaire',
    cta: 'Choisir Famille',
  },
  {
    id: 'presence',
    name: 'Présence plus',
    price: '249',
    monthly: '30',
    tag: '4G intégrée, zéro box requise.',
    features: [
      'Tout de « Famille »',
      'Carte SIM 4G incluse',
      'Fonctionne sans Wi-Fi',
      'Bascule Wi-Fi ↔ 4G automatique',
      'Supervision réseau à distance',
    ],
    featured: false,
    cta: 'Choisir Présence plus',
  },
];

const GUARANTEES = [
  {
    icon: '↩',
    title: '30 jours satisfait ou remboursé',
    desc: 'Retour sans condition dans les 30 jours.',
  },
  {
    icon: '🛡',
    title: '2 ans de garantie',
    desc: "Matériel couvert 2 ans, pièces et main d'oeuvre.",
  },
  { icon: '∞', title: 'Sans engagement', desc: 'Les abonnements sont résiliables à tout moment.' },
  { icon: '⚑', title: 'SAV basé à Lyon', desc: 'Une vraie équipe, pas un chatbot.' },
];

export function Tarifs() {
  return (
    <>
      <Nav active="pricing" />
      <main>
        <div className="page-intro container">
          <div className="eyebrow">Tarifs</div>
          <h1>
            Simple comme <em>bonjour</em>.
          </h1>
          <p className="lede">
            Un seul achat matériel. Un abonnement optionnel pour les familles qui veulent plus.
            Aucun engagement, aucune surprise.
          </p>
        </div>

        <section className="section">
          <div className="container">
            <div className="tarifs-grid">
              {PLANS.map((plan) => (
                <div key={plan.id} className={`tarif-card${plan.featured ? ' featured' : ''}`}>
                  {'badge' in plan && plan.badge && <div className="tarif-badge">{plan.badge}</div>}
                  <div className="serif tarif-name">{plan.name}</div>
                  <div className="tarif-price">
                    <b>{plan.price} €</b>
                    {plan.monthly ? ` + ${plan.monthly} €/mois` : ' · une fois'}
                  </div>
                  <p className="tarif-tag">{plan.tag}</p>
                  <ul>
                    {plan.features.map((f) => (
                      <li key={f}>{f}</li>
                    ))}
                  </ul>
                  <a
                    href="/inscription"
                    className={`btn ${plan.featured ? 'btn-primary' : 'btn-secondary'}`}
                  >
                    {plan.cta}
                  </a>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="section ink">
          <div className="container">
            <div className="section-head-compact">
              <div className="eyebrow">Nos garanties</div>
              <h2>
                On s'engage,
                <em> vraiment</em>.
              </h2>
            </div>
            <div className="confiance-grid">
              {GUARANTEES.map((g) => (
                <div key={g.title} className="conf-item">
                  <div className="conf-icon" aria-hidden="true">
                    {g.icon}
                  </div>
                  <h4>{g.title}</h4>
                  <p>{g.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
